import { useEffect } from "react";

import {
  PropHeroText,
  TEXT_COLOR,
  TEXT_TYPOGRAPHY,
  TEXT_WEIGHT,
} from "@prophero-ds/react-components";

import { useHeaderContext } from "@/contexts/HeaderContext";

import BackButton from "./BackButton";

interface ScreenHeaderWithBackProps {
  title: string;
  description: string;
  onBack?: () => void;
  canGoBack?: boolean;
  backAriaLabel: string;
  backButtonId?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

function ScreenHeaderWithBack({
  title,
  description,
  onBack,
  canGoBack,
  backAriaLabel,
  backButtonId,
  titleClassName,
  descriptionClassName,
}: ScreenHeaderWithBackProps) {
  const { setHasScreenHeaderWithBack } = useHeaderContext();
  const showBackButton = canGoBack !== false && onBack;

  useEffect(() => {
    setHasScreenHeaderWithBack(true);
    return () => {
      setHasScreenHeaderWithBack(false);
    };
  }, [setHasScreenHeaderWithBack]);

  return (
    <div className="flex flex-col items-start gap-4 text-left">
      {showBackButton && (
        <BackButton
          id={backButtonId}
          onClick={onBack!}
          ariaLabel={backAriaLabel}
        />
      )}

      <div className="flex flex-col gap-1">
        <PropHeroText
          typography={TEXT_TYPOGRAPHY["Header-lg"]}
          weight={TEXT_WEIGHT.medium}
          color={TEXT_COLOR.primary}
          className={titleClassName}
        >
          {title}
        </PropHeroText>
        <PropHeroText
          typography={TEXT_TYPOGRAPHY["Text-md"]}
          weight={TEXT_WEIGHT.regular}
          color={TEXT_COLOR.secondary}
          className={descriptionClassName}
        >
          {description}
        </PropHeroText>
      </div>
    </div>
  );
}

export default ScreenHeaderWithBack;
